export default __webpack_public_path__ + "static/media/bitcoin-dojo.ea7209e8.png";